import axios from 'axios';

// [A-16] Logging PHI-safe: solo en desarrollo, y NUNCA el cuerpo de la respuesta
// (fichas, notas clínicas, informes, transcripciones del escriba). En producción
// no se registra nada en la consola del navegador.
const isDev = process.env.NODE_ENV !== 'production';

const apiAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    crossorigin: true
  }
});

apiAxios.interceptors.request.use(
  config => {
    config.headers["Authorization"] = `${localStorage.getItem('token')}`;
    if (isDev) {
      console.log(`[Axios Request] ${config.method.toUpperCase()} ${config.url}`);
    }
    return config;
  },
  error => {
    if (isDev) console.log('[Axios Request Error]', error.message);
    return Promise.reject(error);
  }
);

apiAxios.interceptors.response.use(
  function (response) {
    if (isDev) {
      // Solo método + ruta; sin response.data para no volcar PHI a la consola.
      console.log(`[Axios Response] ${response.config.method.toUpperCase()} ${response.config.url}`);
    }
    return response;
  },
  function (error) {
    if (isDev) {
      console.log(`[Axios Error] ${error.config?.method?.toUpperCase()} ${error.config?.url} → ${error.response?.status || ''}`);
    }
    if (error.response && 401 === error.response.status) {
      window.location = '/login';
    } else {
      return Promise.reject(error);
    }
  });

export default apiAxios;
